/* Foucault · Menú del celular (v6.5). Nativo, sin librerías. Estilos en foucault-v6.css y foucault-v63.css;
   plantilla en snippets/fc-menu.liquid. Pone el pie (tienda, horario, WhatsApp) dentro del menú de Trade.
   La cabeza con el reloj en vivo se quitó en v6.5. */
(function () {
  function iniciar() {
    var drawer = document.getElementById('menu-drawer');
    if (!drawer || drawer.hasAttribute('data-fc-menu')) return;
    drawer.setAttribute('data-fc-menu', '');
    var tPie = document.getElementById('fc-menu-pie');
    var util = drawer.querySelector('.menu-drawer__utility-links');
    if (tPie && util) util.insertBefore(tPie.content.cloneNode(true), util.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
